export default __webpack_public_path__ + "static/media/404.3fb1b585.png";